import React from 'react'
import { Form, Radio } from 'semantic-ui-react'
import LoginMethodCheckboxGroup from 'components/LoginMethodCheckboxGroup'

export default function UserRoleInput({
  isCustomLogin,
  loginMethods,
  allowedRoles,
  defaultDisableSSO,
  defaultRole,
  onChange,
  onChangeDisableSSO,
  onChangeIsCustomLogin,
  onChangeLoginMethods,
  showSSOEnforcementForm,
}) {
  return (
    <React.Fragment>
      <Form.Group grouped>
        <label>Role</label>
        {allowedRoles.map(({ name, label }) => (
          <Form.Field key={name}>
            <div className="ui radio checkbox">
              <input
                id={`${name}-radio`}
                className="hidden"
                type="radio"
                name="roles"
                value={name}
                required
                onChange={(e) => onChange(e.target.value)}
                defaultChecked={defaultRole === name}
              />
              <label htmlFor={`${name}-radio`} className="capitalize">
                {label}
              </label>
            </div>
          </Form.Field>
        ))}
      </Form.Group>
      <p>
        <a
          href="https://help.simplesat.io/en/articles/2361167-users-permissions"
          target="_blank"
          rel="noreferrer"
        >
          <i className="icon far fa-book" />
          Learn more about user roles
        </a>
      </p>
      {showSSOEnforcementForm && (
        <Form.Group grouped>
          <label>SSO enforcement</label>
          <Form.Field>
            <div className="ui checkbox">
              <input
                id="user-disable-sso"
                type="checkbox"
                name="disable_sso"
                defaultChecked={defaultDisableSSO}
                onChange={(e) => onChangeDisableSSO(e.target.checked)}
              />
              <label htmlFor="user-disable-sso" className="!cursor-pointer">
                Disable SSO enforcement
              </label>
            </div>
          </Form.Field>
        </Form.Group>
      )}

      <Form.Group grouped>
        <label>Login methods</label>
        <Form.Field>
          <Radio
            label="Use workspace default"
            checked={isCustomLogin === false}
            onChange={() => onChangeIsCustomLogin(false)}
          />
        </Form.Field>
        <Form.Field>
          <Radio
            label="Customize for this user"
            checked={isCustomLogin === true}
            onChange={() => onChangeIsCustomLogin(true)}
          />
        </Form.Field>
      </Form.Group>

      {isCustomLogin && (
        <LoginMethodCheckboxGroup
          loginMethods={loginMethods}
          label="Manage the login options available"
          onChangeLoginMethods={onChangeLoginMethods}
        />
      )}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/UserRoleInput/index.js